import { TaskName } from '@/common/constants/taskNames.constants';
import { TaskState } from '@schema';
import i18n from '@/common/i18n';
import type { TaskMap } from '@/common/store/modules/tasks/tasksNotificationMapper';

const taskMap: TaskMap = {
  [TaskName.ROLE_SET_ENCRYPTION_ENABLE]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Encryption enabled'),
      message: i18n.t('Encryption successfully enabled')
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Enabling encryption. Please wait...')
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error enabling encryption'),
      message: error
    })
  },
  [TaskName.ROLE_SET_ENCRYPTION_DISABLE]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Encryption disabled'),
      message: i18n.t('Encryption successfully disabled')
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Disabling encryption. Please wait...')
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error disabling encryption'),
      message: error
    })
  },
  [TaskName.ROLE_SET_UPDATE]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Network updated'),
      message: i18n.t('Network successfully updated'),
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Updating network...'),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error updating network'),
      message: error
    })
  },
  [TaskName.ROLE_SET_BULK_UPDATE]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Traffic types successfully updated'),
      message: i18n.t('Traffic types updated'),
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Updating traffic types...'),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error updating traffic types'),
      message: error
    })
  },
  [TaskName.TRAFFIC_TYPE_ASSIGNMENT]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Traffic type successfully updated'),
      message: i18n.t('Traffic type updated'),
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Updating traffic type...'),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error updating traffic type'),
      message: error
    })
  }
};

export default taskMap;
